import { Pipe, PipeTransform } from '@angular/core';
import { Model } from '../models/model';

@Pipe({
    name: 'hidden'
})
export class HiddenPipe implements PipeTransform {
    public transform<T extends Model>(value: T[], all: boolean): T[] {
        if (all) return value;
        else return value.filter(v => !v.deleted);
    }
}
